export const buttonKeyConfig: Record<string, Array<string>> = {
  noteFiles: [ 'contentPaste', 'noteFiles' ]
};

export const iconConfig: Record<string, string>= {
  bloggerContact: 'assignment',
  repeatedRecordListId: 'web_stories',
  history: 'history',
  blogger: 'account_circle',
  bankDetailsId: 'text_snippet',
  statisticsPanel: '',
  documents: 'documents-icon',
  advertisementInitialStatistics: 'initial-statistic',
  initialStatistics: 'initial-statistic',
  statistics: 'statistic',
  advertisementPackage: 'inventory',
  telegram: 'telegram-icon',
  customer: 'person',
  media: 'perm_media',
  chatHistory: 'chat',
  productCard: 'product-card-icon',
  defects: 'defect-icon',
  productPackages: 'inventory',
  declarations: 'description',
  certificates: 'verified',
  factoryBankDetails: 'account_balance_wallet',
  turnkeyCostToWarehouses: 'currency_ruble',
  turnkeyCostToMarketplaces: 'currency_ruble',
  noteChangePrice: 'attach_money',
  technicalConclusions: 'receipt-long',
  productCompositions: 'list_alt',
  listings: 'collections',
  richContent: 'collections',
  aiVideos: 'duo',
  baseVideos: 'duo',
  packageDesignDetails: 'assignment',
  rawPhotos: 'photo_camera',
  rawVideos: 'video_file',
  otherContent: 'archive',
  checkYandex: 'fact_check',
  usp: 'local_offer',
  productValues: 'auto_awesome_motion',
  productDescriptions: 'description',
  productUsageRules: 'rule',
  websiteLinks: 'link',
  websiteBackups: 'backup',
  marketingDrafts: 'drafts',
  changeLimitDto: 'tune',
  banners: 'dynamic_feed ',
  socialMedia: 'screen_share',
  initialVideo: 'video_call',
  finalVideo: 'hd',
  videoFeedback: 'comment',
  nmIds: 'wildberries-icon',
  skus: 'ozon-icon',
  advertisementKey: 'key',
  noPackageModalDto: 'inventory',
  singleItemPackageModalDto: 'inventory',
  transportBoxModalDto: 'inventory',
  palletModalDto: 'inventory',
  truck33PalletsModalDto: 'inventory',
  gazelle6PalletsModalDto: 'inventory',
  gazelle10PalletsModalDto: 'inventory',
  competitorArticles: 'local_offer',
  dates: 'calendar_month',
  testingResultFiles: 'insert_drive_file',
  unitEconomicsCalculations: 'analytics',
  productCardQualityControlApprovals: 'approval',
  productCardGroupModalDto: 'inventory2',
  mainPhoto: 'add_photo_alternate'
};

export const classIconConfig: Record<string, string> = {
  initialStatistics: 'initial-statistic',
  statistics: 'statistic',
  contentPaste: 'content_paste',
  contentPasteGo: 'content_paste_go',
  noteFiles: 'perm_media'
};

export const objectValidationModalKeys: Record<string, string> = {
  initialStatistics: 'initialStatistics',
  statistics: 'statistics',
  advertisementInitialStatistics: 'advertisementInitialStatistics',
  documents: 'documents',
  bankDetails: 'bankDetails',
  blogger: 'blogger',
  bloggerContact: 'bloggerContact',
  telegram: 'telegram',
  customer: 'customer',
  media: 'media',
  productCard: 'productCard',
  defects: 'defects',
  productPackages: 'productPackages',
  declarations: 'declarations',
  certificates: 'certificates',
  factoryBankDetails: 'factoryBankDetails',
  turnkeyCostToWarehouses: 'turnkeyCostToWarehouses',
  turnkeyCostToMarketplaces: 'turnkeyCostToMarketplaces',
  noteChangePrice: 'noteChangePrice',
  noteFiles: 'noteFiles',
  technicalConclusions: 'technicalConclusions',
  productCompositions: 'productCompositions',
  mainPhoto: 'mainPhoto',
  listings: 'listings',
  richContent: 'richContent',
  aiVideos: 'aiVideos',
  baseVideos: 'baseVideos',
  packageDesignDetails: 'packageDesignDetails',
  rawPhotos: 'rawPhotos',
  rawVideos: 'rawVideos',
  otherContent: 'otherContent',
  checkYandex: 'checkYandex',
  usp: 'usp',
  productValues: 'productValues',
  productDescriptions: 'productDescriptions',
  productUsageRules: 'productUsageRules',
  websiteLinks: 'websiteLinks',
  websiteBackups: 'websiteBackups',
  marketingDrafts: 'marketingDrafts',
  changeLimitDto: 'changeLimitDto',
  banners: 'banners',
  socialMedia: 'socialMedia',
  initialVideo: 'initialVideo',
  finalVideo: 'finalVideo',
  videoFeedback: 'videoFeedback',
  nmIds: 'nmIds',
  skus: 'skus',
  advertisementKey: 'advertisementKey',
  noPackageModalDto: 'noPackageModalDto',
  singleItemPackageModalDto: 'singleItemPackageModalDto',
  transportBoxModalDto: 'transportBoxModalDto',
  palletModalDto: 'palletModalDto',
  truck33PalletsModalDto: 'truck33PalletsModalDto',
  gazelle6PalletsModalDto: 'gazelle6PalletsModalDto',
  gazelle10PalletsModalDto: 'gazelle10PalletsModalDto',
  competitorArticles: 'competitorArticles',
  dates: 'dates',
  testingResultFiles: 'testingResultFiles',
  unitEconomicsCalculations: 'unitEconomicsCalculations',
  productCardQualityControlApprovals: 'productCardQualityControlApprovals',
  productCardGroupModalDto: 'productCardGroupModalDto'
};
